import { LitElement, css, html, nothing, unsafeCSS } from 'lit';
import { createRef, ref } from 'lit/directives/ref.js';
import styles from './portal.scss?inline';

export default class SotbitPortal extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        to: { type: String },
        beforeEl: { type: String, attribute: 'before' },
        isInitialHide: { type: Boolean, attribute: 'initialhide' },
        isMoved: { type: Boolean },
    };

    constructor() {
        super();

        this.to = '';
        this.beforeEl = '';
        this.contentRef = createRef();
        this.parentContainer = null;
        this.previousEl = null;
        this.isPositionReceived = false;
        this.isDomLoaded = new Promise((res) => {
            document.addEventListener('DOMContentLoaded', () => {
                res(true);
            });
        });
        this.isInitialHide = false;
        this.isMoved = false;
    }

    moveTo(elSelector, insertBeforeSelector) {
        if (elSelector === 'self' || !elSelector) {
            if (this.previousEl) {
                this.parentContainer.insertBefore(this, this.previousEl.nextSibling);
                return;
            }

            this.parentContainer.prepend(this);
            return;
        }

        const targetElement = document.querySelector(elSelector);

        if (!targetElement) {
            console.error(`Item with ${this.to} selector not found`);
            return;
        }

        if (insertBeforeSelector) {
            const el = targetElement.querySelector(insertBeforeSelector);
            targetElement.insertBefore(this, el);
            return;
        }

        targetElement.appendChild(this);
        this.isMoved = true;
    }

    setInitPosition() {
        if (!this.isPositionReceived) {
            this.parentContainer = this.parentNode;
            this.previousEl = this.previousSibling;
            this.isPositionReceived = true;
        }
    }

    async firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);

        await this.isDomLoaded;
        this.setInitPosition();
    }

    async attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        await this.isDomLoaded;
        this.setInitPosition();

        if (name === 'before' && this.to) {
            this.moveTo(this.to, value);
            return;
        }

        if (name === 'to') {
            if (!this.to || this.to === 'self') {
                this.moveTo();
                return;
            }

            this.moveTo(value);
        }
    }

    render() {
        return html`
            <div style="${this.isInitialHide && !this.isMoved ? 'display: none' : nothing}">
                <slot ${ref(this.contentRef)} @slotchange=${this.handleSlotchange}></slot>
            </div>
        `;
    }
}
